


































































































































import {Vue, Component, Provide} from 'vue-property-decorator';
import {API} from '@/services/api/api';
import {Utils} from '@/utils/Utils';
import {mapActions} from 'vuex';
import {acceptedImageTypes, redirectTime} from '@/constants/constants';
import {extractDetailsFromBase64, mergeBase64toImage} from '@/services/api/image';
import BackButton from '@/components/BackButton.vue';
@Component({
  methods: {...mapActions(['showSuccessToast', 'showErrorToast'])},
  components: {
    BackButton,
  },
})
export default class EditNews extends Vue {
  //Store Variables
  showSuccessToast: any;
  showErrorToast: any;
  acceptedImageTypes = acceptedImageTypes;

  //Form Variables
  newsId: any = null;
  newsHeading = '';
  newsDescription = '';
  imagebase64URL = '';
  imageName = '';
  newsStatus: any = null;

  //Validaton Variables
  imageValidationMsg: any = null;
  headingValidationMsg: any = null;
  descValidationMsg: any = null;

  //Loader Variables
  loadingBtnStatus = false;
  isScreenLoading = true;

  mounted() {
    this.newsId = this.$route.params.id;
    this.getNewsDetails();
  }

  // get particular news details
  async getNewsDetails() {
    try {
      let apiResponse = await API.fetchNewsDetailsById(this.newsId);
      this.isScreenLoading = false;

      if (apiResponse.data) {
        const data = apiResponse.data;
        this.newsHeading = data.newsHeading;
        this.newsDescription = data.newsDescription;
        this.newsStatus = data.newsIsActive;
        this.imageName = data.newsImageName;
        let imageURL = data.newsImage;
        this.imagebase64URL = imageURL ? mergeBase64toImage(data.imageType, imageURL) : '';
      } else {
        this.showErrorToast({msg: apiResponse.error});
      }
    } catch (error) {
      this.isScreenLoading = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  //convert image into base 64 string and display on screen
  async onFileChange(event: any) {
    const imageData = event.target.files[0];
    this.imageName = imageData.name;

    try {
      let base64url = await Utils.ngxBase64(imageData);
      if (base64url === null) alert('Something went wrong with image');
      else {
        this.imageValidationMsg = null;

        return (this.imagebase64URL = base64url);
      }
    } catch (error) {
      alert('Something went wrong with image');
    }
  }

  validateNewsHeading() {
    if (this.newsHeading === '' || this.newsHeading.trim().length < 1) {
      this.headingValidationMsg = 'This field is required.';
      return false;
    } else if (this.newsHeading.trim().length < 5) {
      this.headingValidationMsg = 'Minimum 5 characters required.';
      return false;
    } else {
      this.headingValidationMsg = null;
      return true;
    }
  }
  validateDescription() {
    if (this.newsDescription === '' || this.newsDescription.trim().length < 1) {
      this.descValidationMsg = 'This field is required.';
      return false;
    } else if (this.newsDescription.trim().length < 5) {
      this.descValidationMsg = 'Minimum 5 characters required.';
      return false;
    } else {
      this.descValidationMsg = null;
      return true;
    }
  }

  validateAll() {
    return this.validateNewsHeading() && this.validateDescription();
  }

  //submit button handler
  async _updateHandler() {
    if (!this.validateAll()) {
      return false;
    }
    try {
      this.loadingBtnStatus = true;
      let {imageType, url} = extractDetailsFromBase64(this.imagebase64URL);
      const formData = {
        newsHeading: this.newsHeading,
        newsDescription: this.newsDescription,
        newsImageName: this.imageName,
        newsImage: url,
        imagetype: imageType,
        newsisactive: this.newsStatus,
      };

      let response = await API.updateNews(this.newsId, formData);
      this.loadingBtnStatus = false;
      if (response.data) {
        let message: string = response.message;
        if (message.includes('updated news')) message = 'Record updated successfully';
        this.showSuccessToast({msg: message});
        setTimeout(() => this._clickHanlder(), redirectTime);
      } else {
        this.showErrorToast({msg: response.error});
      }
    } catch (error) {
      this.loadingBtnStatus = false;
      this.showErrorToast({msg: 'Network error'});
    }
  }

  _clickHanlder() {
    this.$router.go(-1);
  }
}
